import React, { useState, useEffect } from "react";
import OtpModal from "../../Containers/otp/OtpModal";
import Header from "../../Containers/Header";
import login_image from "../../assets/Loginbanner.png";
import "./UserLogin.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { loginSchema } from "../../utils/Validations";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  userLogin,
  otpSend,
  clearLoadingMessageStatus,
} from "../../redux/actions/UserAccount";
import Backdrop from "../../Containers/modal/BackDrop";
import Modal from "../../Containers/modal/Modal";
import { languageJson } from "../../StringVariable";
import oaklandlogo from "../../assets/new_logo.png";
import loginLogo from "../../assets/login.svg";

function UserLogin() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loadingState, messageState, statusCodeState } = useSelector(
    (state) => state
  );
  const formOptions = { resolver: yupResolver(loginSchema) };
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;
  const [passwordShown, setPasswordShown] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [emailId, setEmail] = useState("");
  const [onModal, setOnModal] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const handleSubmitLogin = (loginData, e) => {
    if (!onModal) {
      const { email, password } = loginData;
      dispatch(userLogin({ email, password }, history));
      setEmail(email);
    }
  };

  const closeModalHandler = () => {
    dispatch(clearLoadingMessageStatus());
    setOnModal(false);
    setEmail("");
  };
  const closeModal = () => {
    dispatch(clearLoadingMessageStatus());
    setOnModal(false);
    setEmail("");
    setShowOTP(false);
  };

  useEffect(() => {
    if (statusCodeState.loginStatusCode === 210) {
      getEmailOTP();     
    }
    if (statusCodeState.loginStatusCode !== null) {
      setOnModal(true);
    }
  }, [statusCodeState.loginStatusCode]);

  useEffect(() => {
      if (statusCodeState.otpSendStatusCode === 215) {
        dispatch(clearLoadingMessageStatus());
        setOnModal(false);
        setShowOTP(false);
      }else if (statusCodeState.loginStatusCode === 210){
        setShowOTP(true);
      } 
  }, [statusCodeState.otpSendStatusCode]);

  const getEmailOTP = () => {
    const emailData = { email: emailId };
    dispatch(otpSend(emailData,history));
  };

  return (
    <div>
      <Header />
      <div className="headerBannerMainDiv">
        <img className="vessel_img" src={login_image} alt="vessel" />
      </div>
      <div className="center-underline text-center" id="loginpage">
        <h2 className=" loginhead  pt-5">
          {languageJson.user_txt} {languageJson.login_txt}
        </h2>
      </div>
      <div className="py-5">
        <p className="text-center logindesc">
          {languageJson.userlogin_Descp_txt}
        </p>
      </div>
      <section className="loginsection pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-1"></div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center loginImageLogo custom-half form-section-img">
              <img src={loginLogo} alt="Login image" className="imageLogo" />
            </div>
            <div className="col-lg-5 form-section-form">
              <form
                onSubmit={handleSubmit(handleSubmitLogin)}
                autoComplete="off"
              >
                <div className="text-center mb-4 mt-4">
                  <img
                    src={oaklandlogo}
                    alt="Oakland Logo"
                    className="imageLogin"
                  />
                  <p className="mt-3 textLogin">
                    {languageJson.login_with_account}
                    {/* Login with your oakland portal account */}
                  </p>
                </div>
                <div className="form-group">
                  <div className="col-sm-10 mx-auto width60">
                    <input
                      className="form-control form-control-glow"
                      name="email"
                      id="email"
                      type="text"
                      placeholder={languageJson.enter_email_address_txt}
                      {...register("email")}
                    />
                    <p className="text-danger">{errors.email?.message}</p>
                  </div>
                </div>
                <div className="form-group" id="password-wrapper">
                  <div className="col-sm-10 mx-auto emaildiv width60">
                    <input
                      className="form-control form-control-glow"
                      name="password"
                      id="password"
                      type={passwordShown ? "text" : "password"}
                      autoComplete="new-password"
                      placeholder={languageJson.enter_pwd_txt}
                      {...register("password")}
                    />
                    <span
                      id="togglePassword"
                      toggle="#password-field"
                      className={`${
                        passwordShown
                          ? "fa fa-fw fa-eye-slash"
                          : "fa fa-fw fa-eye"
                      } field-icon toggle-password eyeiconspan`}
                      onClick={togglePassword}
                    ></span>
                    <p className="text-danger">{errors.password?.message}</p>
                  </div>
                </div>
                <div className="forgotBtn d-flex justify-content-end align-items-center mb-4 custom-padding">
                  <Link to="/forgotPassword">
                    <span className="darkblue text-decoration-none cursor-pointer">
                      {languageJson.forgot_password_txt}
                    </span>
                  </Link>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    type="submit"
                    className="btn login-btn btn-block btnHover width60"
                    disabled={loadingState.isLoginLoading ? true : false}
                  >
                    {loadingState.isLoginLoading
                      ? languageJson.processing_txt
                      : languageJson.userAuth.login}
                  </button>
                </div>
                <div className="d-flex align-items-center justify-content-center my-4">
                  <p className="text-center  mx-3 mb-0 text-dark">
                    {languageJson.dont_account_txt}{" "}
                    <Link to="/selectusertype#selectusertype">
                      {" "}
                      <span className="darkblue text-decoration-none cursor-pointer">
                        {languageJson.userAuth.register}
                      </span>
                    </Link>
                  </p>
                </div>
              </form>
            </div>
            <div className="col-lg-1"></div>
          </div>
          {statusCodeState.loginStatusCode != null &&
            statusCodeState.loginStatusCode !== 210 && (
              <React.Fragment>
                <Backdrop onClick={() => closeModalHandler()} />
                <Modal
                  text={messageState.loginMessage}
                  btnColor="modal-btn-warning"
                  icon="fa fa-exclamation-circle"
                  status="bg-warning"
                  onClose={closeModalHandler}
                />
              </React.Fragment>
            )}
          {showOTP ? (
            <React.Fragment>
              <Backdrop onClick={() => closeModal()} />
              <OtpModal
                text={
                  messageState.loginMessage
                    ? messageState.loginMessage
                    : languageJson.enter_OTP_email_txt
                }
                resendOTP={() => getEmailOTP()}
                email={emailId}
                status={"bg-custom-success"}
                btnColor={"modal-btn-success"}
                icon={"fa fa-check-circle"}
                onClose={() => closeModal()}
              />
            </React.Fragment>
          ) : null}
        </div>
      </section>
    </div>
  );
}

export default UserLogin;
